export const getStickyContainerStatus = (
  show: boolean,
  scrollY: number,
  showAfterScrolling: number,
  positionRefCurrent: number,
  position: 'top' | 'bottom'
): { shouldShow: boolean; newRefPosition: number } => {
  let shouldShow = show;
  let newRefPosition = positionRefCurrent;

  const scrolledDown =
    show && position === 'bottom' ? scrollY > positionRefCurrent - 100 : scrollY > positionRefCurrent;

  if (position === 'top' || scrollY >= showAfterScrolling) {
    shouldShow = position === 'bottom' ? scrolledDown : !scrolledDown;

    if (position === 'top') {
      newRefPosition = scrollY;
      // If 'bottom', we update the ref after 100 px so element doesn't disappear immediately when user scrolls back up
    } else if (Math.abs(scrollY - positionRefCurrent) > 100) {
      newRefPosition = scrollY;
    }
  }

  // For edge case where user scrolls beyond threshold, but not 100px past to reset ref
  if (position === 'bottom' && scrollY < showAfterScrolling) {
    shouldShow = false;
    newRefPosition = 0;
  }

  return { shouldShow, newRefPosition };
};
